import api from "./api";

/**
 * Send message to AI Chat API
 * @param {string} message - The text message sent by the user
 * @returns {Promise<Object>} API response object
 */
export const sendChatMessage = async (message) => {
  try {
    const response = await api.post("/v1/api/ai/chat", { message });
    return response;
  } catch (error) {
    console.error("AI Chat API Error:", error);
    throw error;
  }
};

/**
 * Confirm or reject pending action
 * @param {string} pendingActionId - The token/id of the pending action
 * @param {boolean} confirmStatus - true to confirm, false to cancel
 * @returns {Promise<Object>} API response object
 */
export const confirmAiAction = async (pendingActionId, confirmStatus = true) => {
  try {
    const response = await api.post("/v1/api/ai/confirm", {
      pending_action_id: pendingActionId,
      confirm: confirmStatus,
    });
    return response;
  } catch (error) {
    console.error("AI Confirm API Error:", error);
    throw error;
  }
};
